module.exports = __webpack_public_path__ + "img/linkedin.bd89c9ea.svg";